import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import Checkbox from 'react-bootstrap/lib/Checkbox';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

import * as date from '../utils/date-fns';

const TALK_DEFAULT = 0;
const TALK_UNLIMITED = 21;

const DATA_DEFAULT = 0;
const DATA_UNLIMITED = 20;

const UNLIMITED_TALKTIME = 20;
const ALL_TALKTIME = 0;
const DEFAULT_TALKTIME = 5;

// const ALL_DATA = 0;
const DEFAULT_DATA = 10;
const ALL_DATA = 0;
const UNLIMITED_DATA = 30;

const DEFAULT_PRICE = 100;
const UNLIMITED_PRICE = 225;

const ALL_MSG = '';

const FILTER_GROUPS = [
  {
    headline: null,
    filters: [
      { label: '4G', key: 'lte' },
      { label: 'Fri SMS/MMS', key: 'freeMsg' },
      { label: 'Gratis oprettelse', key: 'freeSignup' },
      { label: 'Ingen binding', key: 'noCommitment' }
    ]
  },
  {
    headline: null,
    filters: [
      { label: 'Mobilabonnement', key: 'subscription' },
      { label: 'Taletidskort', key: 'prepaid' }
    ]
  }
];

class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    const isPrepaid =
      props.filters &&
      !props.filters.subscription &&
      props.filters.prepaid !== false;

    this.state = this.mapPropsToState(props, {
      offerType: 'mobilabonnement',
      ...this.state,
      sort: this.createSort(props.sort || { 'price.monthly': 1, weight: -1 }),
      defaultFilters: { // FOR FILTERS_USED EPI
        talktime: !isPrepaid ? TALK_DEFAULT : null,
        data: !isPrepaid ? DATA_DEFAULT : null,
        price: null,
        lte: false,
        freeMsg: false,
        prepaid: true,
        subscription: true,
        tags: []
      },
      filters: {
        talktime: !isPrepaid ? TALK_DEFAULT : null,
        data: !isPrepaid ? DATA_DEFAULT : null,
        price: null,
        lte: false,
        freeMsg: false,
        prepaid: true,
        subscription: true,
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const isPrepaid =
      this.props.filters &&
      !this.props.filters.subscription &&
      this.props.filters.prepaid !== false;

    const filters = {
      ...(this.state.filters || {}),
      talktime: !isPrepaid ? TALK_DEFAULT : null,
      data: !isPrepaid ? DATA_DEFAULT : null,
      price: null,
      lte: false,
      freeMsg: false,
      prepaid: true,
      subscription: true,
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  createFilter(filters) {
    const regexHours = /\d+ timer?/;
    const regexDigit = /^\d+/;

    const filterTags = ['lte', 'freeMsg', 'freeSignup', 'noCommitment'].filter(
      tag => filters[tag]
    );
    function hasFilterTags(tags) {
      return !filterTags.reduce(
        (status, tag) => status || !tags.includes(tag),
        false
      );
    }

    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.getIn(['_raw', 'tags']));
        const manualTags = offer.getIn(['_raw', 'manualTags']) ? Array.from(offer.getIn(['_raw', 'manualTags'])) : [];
        const mergedTags = tags.reduce((acc, tag) => {
          if(!acc.includes(tag)) {
            acc.push(tag);
          }
          return acc;
        }, manualTags || []).filter(Boolean);

        const isPrepaid = mergedTags.includes('prepaid');
        if (
          filters.prepaid !== null &&
          filters.prepaid !== filters.subscription &&
          filters.prepaid !== isPrepaid
        ) {
          return false;
        }

        if (!isPrepaid) {
          // Talk time
          const talktime = offer.getIn(['_raw', 'rates', 'talktime']);
          const hasFreeSpeech =
            mergedTags.includes('freeSpeech') ||
            talktime === 'Fri tale';

          if (filters.talktime) {
            if (filters.talktime === TALK_UNLIMITED && !hasFreeSpeech) {
              return false;
            }

            if (!hasFreeSpeech && regexHours.test(talktime)) {
              const hours = regexDigit.exec(talktime)[0];
              if (hours < filters.talktime) {
                return false;
              }
            }
          }

          // Data
          if (filters.data) {
            const amount = offer.getIn(['_raw', 'rates', 'data', 'amount']);
            const unit = offer.getIn(['_raw', 'rates', 'data', 'unit']);

            if ((unit === 'GB' && amount < filters.data) || unit !== 'GB') {
              return false;
            }
          }
        }

        // Total price per month
        if (filters.price !== null) {
          if (
            filters.price !== UNLIMITED_PRICE &&
            filters.price < offer.getIn(['_raw', 'price', 'monthly'])
          ) {
            return false;
          }
        }

        const lowerCaseTags = mergedTags.map(i => i.toLowerCase());
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const filteredTags = filters.tags;
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !mergedTags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider
            ) {
            return false;
          }
        }

        return true;
      });
  }

  serialiseOffer(offer) {
    function priceHelper(price) {
      if (!price || !/^[0-9.,]+$/.test(price)) {
        return price || null;
      }
      return price < 1
        ? {
            price: price * 100,
            unit: 'øre'
          }
        : {
            price: price.toString().replace('.', ','),
            unit: 'kr.'
          };
    }

    const tags = Array.from(offer.get('tags') || []);
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    const prepaid = mergedTags.includes('prepaid');

    const talktimeNotIncluded = /^\d*[.,]\d*$/.exec(
      offer.getIn(['rates', 'talktime'])
    );
    const talktime = (offer.getIn(['rates', 'talktime']) || '').replace(
      / (timer?|tale)/i,
      ''
    );
    const hasFreeSpeech =
      mergedTags.includes('freeSpeech') ||
      mergedTags.includes('Fri tale') ||
      talktime === 'Fri tale' ||
      talktime === 'Fri';

    const dataUnit = (offer.getIn(['rates', 'data', 'unit']) || '').split('/');
    const dataIncluded = /^[MG]B$/.test(dataUnit[0]);
    const freeData = /fri/i.test(offer.getIn(['rates', 'data', 'unit']));

    const freeMsg = mergedTags.includes('freeMsg');
    const freeSms = mergedTags.includes('freeSms');

    let remark = '';
    const discounted = offer.get('discountPrice') && offer.get('discountPrice') < offer.getIn(['price', 'monthly']);
    const period = discounted ? offer.get('discountPeriod') : offer.getIn(['period', 'duration']);
    const monthlyPrice = discounted ? offer.get('discountPrice') : offer.getIn(['price', 'monthly']);
    const lowestPrice = (Math.max(1, period) * monthlyPrice) + offer.getIn(['price', 'startup']);

    if (period === 0) {
      remark = `Ingen binding og mindsteprisen er ${lowestPrice} kr.${
        offer.getIn(['price', 'startup'])
          ? `, heraf ${offer.getIn(['price', 'startup'])} kr. i oprettelse.`
          : ''
      }`;
    } else if (period == 6) {
      remark = `6 måneders binding og mindsteprisen er ${lowestPrice} kr.${
        offer.getIn(['price', 'startup'])
          ? `, heraf ${offer.getIn(['price', 'startup'])} kr. i oprettelse.`
          : ''
      }`;
    } else {
      remark = `${period} ${
        period === 1 ? 'måneds' : 'måneders'
      } binding og mindsteprisen er ${lowestPrice} kr.${
        offer.getIn(['price', 'startup'])
          ? `, heraf ${offer.getIn(['price', 'startup'])} kr. i oprettelse.`
          : ''
      }`; // og prisen for 6 måneder er ${offer.getIn(['price', 'sixMonths'])} kr. *`;
    }
    if (offer.getIn(['price', 'call'])) {
      const price = offer.getIn(['price', 'call']);
      remark +=
        ' ' +
        (price < 1
          ? `${Math.round(price * 100)} øre`
          : `${price.toString().replace('.', ',')} kr`) +
        ' i opkaldsafgift.';
    }

    const details = [];

    if (prepaid) {
      const mms =
        !freeMsg &&
        offer.getIn(['price', 'mms']) &&
        priceHelper(offer.getIn(['price', 'mms']));

      const talk = priceHelper(offer.getIn(['price', 'minute']));
      details.push({
        value: talk ? talk.price : talktime,
        unit: talk
          ? talk.unit
          : hasFreeSpeech
          ? ''
          : `time${talktime === '1' ? '' : 'r'}`,
        label: talk ? 'Tale (pr minut)' : 'Tale'
      });

      const data = priceHelper(offer.getIn(['price', 'data']));
      const dataAlt =
        dataUnit[1] && priceHelper(offer.getIn(['rates', 'data', 'amount']));
      details.push({
        value: freeData ? 'Fri' : data ? data.price : dataAlt ? dataAlt.price : '-',
        unit: freeData ? '' : data ? data.unit : dataAlt ? dataAlt.unit : '',
        label: freeData ? 'Data' : data
          ? 'Data (pr MB)'
          : dataAlt
          ? `Data (pr ${dataUnit[1]})`
          : 'Data'
      });

      details.push({
        value: freeMsg
          ? offer.getIn(['rates', 'msg'])
          : freeSms
          ? 'Fri'
          : Math.round(offer.getIn(['price', 'sms']) * 100),
        unit: freeMsg || freeSms ? '' : 'øre', // øre/besked
        label: freeMsg ? 'SMS/MMS' : 'SMS'
      });

      if (mms) {
        details.push({
          value: mms.price,
          unit: `${mms.unit}`, // ${mms.unit}/besked
          label: 'MMS'
        });
      }

      details.push({
        value: offer.getIn(['price', 'startup']),
        unit: 'kr.',
        label: 'Oprettelse',
        palm: 'hidden'
      });

      details.push({
        value: period,
        unit: 'mdr.',
        label: 'Binding',
        palm: 'hidden'
      });

      if (!mms) {
        details.push({
          value: lowestPrice,
          unit: 'kr.',
          label: 'Mindstepris',
          palm: 'hidden'
        });
      }
    } else {
      details.push(
        {
          value: talktime,
          unit: talktimeNotIncluded
            ? 'kr.'
            : hasFreeSpeech
            ? ''
            : `time${talktime === '1' ? '' : 'r'}`,
          label: talktimeNotIncluded ? 'Tale (pr minut)' : 'Tale'
        },
        {
          value: freeData ? 'Fri' : offer.getIn(['rates', 'data', 'amount']),
          unit: freeData ? '' : dataUnit[0],
          label: freeData || dataIncluded ? 'Data' : `pr. ${dataUnit[1]}`
        },
        {
          value: freeMsg
            ? offer.getIn(['rates', 'msg'])
            : freeSms
            ? 'Fri'
            : offer.getIn(['price', 'sms']),
          unit: freeMsg || freeSms ? '' : 'kr.',
          label: freeMsg ? 'SMS/MMS' : freeSms ? 'SMS' : 'pr. SMS'
        }
      );
      details.push(
        {
          value: offer.getIn(['price', 'startup']),
          unit: 'kr.',
          label: 'Oprettelse',
          palm: 'hidden'
        },
        {
          value: period,
          unit: 'mdr.',
          label: 'Binding',
          palm: 'hidden'
        },
        {
          value: lowestPrice,
          unit: 'kr.',
          label: 'Mindstepris',
          palm: 'hidden'
        }
      );
    }

    // console.log(talktime, offer.get('rates'), offer.get('price'));

    const serialised = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      // logo: `${config.path.images}/${offer.get('imageUrl')}`,
      logo: offer.getIn(['image', 'hash'])
        ? `${config.images}${offer.getIn(['image', 'hash'])}`
        : null,
      link: `/redirect/${offer.get('uuid')}`,
      orderText: 'Bestil nu',

      tagline: offer.get('tagline'),
      expire: date.format(offer.get('expire'), 'D. MMM'),

      details,

      price: {
        value: monthlyPrice,
        unit: 'kr.',
        label: prepaid ? 'Abonnement' : 'per måned',
        old: discounted
            ? offer.getIn(['price', 'monthly'])
            : null
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      remarks: remark
        ? {
            headline: 'Omkostninger:',
            text: remark.trim()
          }
        : null,

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),

      _raw: offer
    });

    return serialised;
  }

  createSearchDisplay(filters) {
    const display = [];

    const talktime = filters.talktime;
    if (talktime) {
      if (talktime === TALK_UNLIMITED) {
        display.push('Fri tale');
      } else {
        display.push(parseInt(talktime) + ' timer');
      }
    }
    if (filters.data) {
      display.push(filters.data + 'GB Data');
    }
    if (filters.price) {
      display.push(parseInt(filters.price) + ' kr.');
    }
    if (filters.lte) {
      display.push('4G');
    }
    if (filters.freeMsg) {
      display.push('Fri SMS/MMS');
    }

    // TODO: Iterate through filter groups

    return display;
  }

  headlinePrice(price) {
    if (price) {
      if (price[0] == UNLIMITED_PRICE) {
        return 'Alle';
      } else {
        return `${parseInt(price[0])} kr.`;
      }
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;

    const onlyPrepaid = filters.prepaid && !filters.subscription;

    //  palm={onlyPrepaid ? 'hidden' : '1/1'}

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Mobilabonnement'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup disabled={onlyPrepaid}>
              <Slider
                name='talktime'
                headline={[
                  'Tale',
                  values => {
                    if (
                      filters.talktime === null ||
                      filters.talktime === 0 ||
                      onlyPrepaid
                    ) {
                      return '';
                    }

                    if (filters.talktime === TALK_UNLIMITED) {
                      return 'Fri tale';
                    }

                    const val =
                      values[0] < 1
                        ? Math.round(values[0] * 10) / 10
                        : parseInt(values[0]);
                    return val < 1
                      ? `${val * 60} min`
                      : `${val} time${val === 1 ? '' : 'r'}`;
                  }
                ]}
                units={['0 min', 'Fri tale']}
                range={{
                  min: [0, 0.1],
                  '20%': [1, 1],
                  max: [TALK_UNLIMITED]
                }}
                connect='lower'
                disabled={onlyPrepaid}
                defaultStart={[filters.talktime || TALK_DEFAULT]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>

            <SearchGroup disabled={onlyPrepaid}>
              <Slider
                name='data'
                headline={[
                  'Data',
                  values => {
                    if (filters.data === null || onlyPrepaid) {
                      return '';
                    }

                    if (values[0] == DATA_UNLIMITED) {
                      return `${DATA_UNLIMITED}+ GB`;
                    }

                    const val =
                      values[0] < 1
                        ? Math.round(values[0] * 10) / 10
                        : parseInt(values[0]);
                    return val < 1 ? `${val * 1000} MB` : `${val} GB`;
                  }
                ]}
                units={['0 MB', `${DATA_UNLIMITED}+ GB`]}
                range={{
                  min: [0, 0.1],
                  '15%': [1, 1],
                  max: [DATA_UNLIMITED]
                }}
                connect='lower'
                disabled={onlyPrepaid}
                defaultStart={[filters.data || DATA_DEFAULT]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>

            {/*
              <SearchGroup disabled={onlyPrepaid}>
              <Slider
              name='price'
              headline={['Pris (max pr. md.)', val => filters.price === null ? '' : this.headlinePrice(val) ]}
              units={['50 kr.', '200 kr. | Alle']}
              range={{
              'min': [50, 10],
              '50%': [DEFAULT_PRICE, 25],
              'max': [UNLIMITED_PRICE]
              }}
              disabled={onlyPrepaid}
              defaultStart={[filters.price || DEFAULT_PRICE]}
              onSlide={this.sliderOnChange}
              />
              </SearchGroup>
            */}

            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Bestil' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default connect(({ cellphone: { offers } }) => ({ offers }))(
  withRouter(Offers)
);
